// extracted by mini-css-extract-plugin
export default {"aside":"aside_aside__zsm3G","option":"aside_option__M2TWP","selected":"aside_selected__8LKUk","opened":"aside_opened__nZFi4"};